module.exports = __webpack_public_path__ + "img/stock6.126b43bd.png";